var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('fade-in-top-title',{staticClass:"title-interval"},[_c('h3',[_vm._v("Contact")])]),_c('div',{staticClass:"container"},[_c('router-view',{attrs:{"user":_vm.user},on:{"update:user":function($event){_vm.user=$event}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }